module.exports = __webpack_public_path__ + "img/system-development-banner-test.5dd1df2f.jpg";